// Utilise i18n-iso-countries to get list of countries based on specified language
import countries from 'i18n-iso-countries';

// Full list of supported languages can be found here: https://www.npmjs.com/package/i18n-iso-countries?activeTab=readme
import en from 'i18n-iso-countries/langs/en.json';
import fr from 'i18n-iso-countries/langs/fr.json';
import de from 'i18n-iso-countries/langs/de.json';
import ca from 'i18n-iso-countries/langs/ca.json';
import es from 'i18n-iso-countries/langs/es.json';
import pt from 'i18n-iso-countries/langs/pt.json';
import it from 'i18n-iso-countries/langs/it.json';
import nl from 'i18n-iso-countries/langs/nl.json';
import fi from 'i18n-iso-countries/langs/fi.json';

// Each language needs to be registered to be usable
const locales = { en, // English
    fr, // French
    de, // German
    ca, // Catalan
    es, // Spanish
    pt, // Portuguese
    it, // Italian
    nl, // Dutch
    fi, // Finnish
};
Object.values(locales).forEach(locale => countries.registerLocale(locale));

/**
 * Get a dictionary of countries
 * @param {string} language The user's language
 * @return {Dict} Dictionary of countries. Example: { 'AF': 'Afghanistan', 'AL': 'Albania', [...], 'ZM': 'Zambia', 'ZW': 'Zimbabwe' }
 */
export const getCountriesList = (language) => {
    // i18n-iso-countries only supports languages mentioned in:
    // https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
    // Therefore, we only care about the prefix before '-' (i.e: en for en-GB, en-US, en-CA)
    let formatLanguage = language.split('-')[0];

    return countries.getNames(formatLanguage, {select: 'official'});
};
